﻿import {UISprite} from "../../UI/Tools/Base/UISprite";

function genHitmap(baseTex, threshold) {
    if (!baseTex.resource || !baseTex.resource.source) return false;
    const imgSource = baseTex.resource.source;
    let canvas = null;
    let context = null;
    if (imgSource.getContext) {
        canvas = imgSource;
        context = canvas.getContext('2d');
    } else if (imgSource instanceof Image) {
        canvas = document.createElement('canvas');
        canvas.width = imgSource.width;
        canvas.height = imgSource.height;
        context = canvas.getContext('2d');
        context.drawImage(imgSource, 0, 0);
    } else {
        return false;
    }

    const w = canvas.width, h = canvas.height;
    let imageData = context.getImageData(0, 0, w, h);
    //create array
    let hitmap = baseTex.hitmap = new Uint32Array(Math.ceil(w * h / 32));
    //fill array
    for (let i = 0; i < w * h; i++) {
        //lower resolution to make it faster
        let ind1 = i % 32;
        let ind2 = i / 32 | 0;
        //check every 4th value of image data (alpha number; opacity of the pixel)
        //if it's visible add to the array
        let a = imageData.data[i * 4 + 3];
        if (a !== 0 && a >= threshold) {
            hitmap[ind2] = hitmap[ind2] | (1 << ind1);
        }
    }
    return true;
}

export class EntityView extends UISprite {

    Awake() {
        this.pointerId = null;
        this.wrapper = this.addChild(new PIXI.Container);
        this.sprite = this.wrapper.addChild(new UISprite());
        this.fitLayout(Core.app.viewport);
    }

    fitLayout(viewport) {
        this.wrapper.scale.set((viewport.width / 6) / 120);
    }

    Place(position) {
        this.position.copyFrom(position);
    }

    canInteract(p = null) {
        if (!this.Active) return false;
        return p ? this.containsPoint(p) : true;
    }

    canMerge(otherCreature = null, checkPosition = false) {
        return false;
    }

    // Overriding this method for more precise hit test detection
    containsPoint(point, pixelCheck = true) {
        // if (!this.sprite.containsPoint(point)) return false;
        // return true;

        const local = {x: 0, y: 0};
        this.sprite.worldTransform.applyInverse(point, local);

        const {width, height} = this.sprite._texture.orig;

        // Fast AABB check
        const x = -width * this.sprite.anchor.x;
        const y = -height * this.sprite.anchor.y;
        if (local.x < x || local.x > x + width || local.y < y || local.y > y + height) return false;

        if (!pixelCheck) return true;

        // bitmap check
        const tex = this.sprite.texture;
        const baseTex = tex.baseTexture;
        const res = baseTex.resolution;

        if (!baseTex.hitmap && !genHitmap(baseTex, 255)) return true;

        // this does not account for rotation!!!
        const hitmap = baseTex.hitmap;

        //check mouse position if its over the sprite and visible
        let dx = Math.round((local.x - x + tex.frame.x) * res);
        let dy = Math.round((local.y - y + tex.frame.y) * res);
        let ind = (dx + dy * baseTex.realWidth);
        let ind1 = ind % 32;
        let ind2 = ind / 32 | 0;
        return (hitmap[ind2] & (1 << ind1)) !== 0;
    }

    mouseDown(p) {
    }

    mouseMove(p) {
    }

    mouseUp(p) {
    }

    Update() {
        if (!this.offsetStartInited) {
            this.offsetStartX = this.x;
        }
    }

    CompareTo(other) {
        if (!other) return 0;
        return (this.y - other.y) || 0;
    }

}
